import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { GlobalService } from 'src/app/_services/global.service';
import { MessagesControlService } from 'src/app/_services/messages-control.service';
import { CreateMessageFacade } from '../../_services/createMessage.facade';
import { MessagesService } from '../../_services/messages.service';

declare var $: any;

@Component({
  selector: 'app-select-users-manually',
  templateUrl: './select-users-manually.component.html',
  styleUrls: ['./select-users-manually.component.scss']
})
export class SelectUsersManuallyComponent implements OnInit {
  currentView: string = 'list';
  checkedList = new Subject();
  selectedUsersIds = [];
  currLang;
  constructor(
    private globalService: GlobalService,
    private translate: TranslateService,
    private messageControl: MessagesControlService,
    public dialogRef: MatDialogRef<SelectUsersManuallyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private createMessageFacade: CreateMessageFacade, private messagesService: MessagesService
  ) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  ngOnInit(): void {
    // to preselect the usersid from dashboard "Not using bluride" inside the table 
    // this.messageControl.getMessagedRows().subscribe(res=>{
    //   if(res != null){
    //     this.selectedUsersIds = res
    //     this.createMessageFacade.setSelectedUsersIds(this.selectedUsersIds);
    //     this.messagesService._areMultipleRecepientsSelected.next(true)
    //   }
    // })
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.createMessageFacade.getFiltersOptions$().subscribe(data => {
      this.selectedUsersIds = this.data.selectedUsers.value;
      this.addSelectedFlagToUsers();
      if (data) {
        Object.assign(this.data.rolesArray, data);  // this will change the existing object.        
      }
    })

    this.selectedUsersIds = this.data.selectedUsers.value;
    this.addSelectedFlagToUsers();
  }
  addSelectedFlagToUsers() {
    this.data.tableControls.data.forEach(element => {
      element["isSelected"] = this.selectedUsersIds.includes(element.id) ? true : false;
    });
  }
  
  changeView($event) {
    this.currentView = $event;
  }
  searchChanged($event) {
    this.messagesService.setSearchTermUsers($event);
  }
  handleCheckedList(event) {
    this.checkedList.next(event);
  }
  getCheckedList$() {
    return this.checkedList.asObservable();
  }

  checkboxesHandler(event) {
    const userId = event.target.data.id;
    // to handle select all , dataValues means select all is clicked , it can be checed or unchecked
    if(event.target.dataValues){
      if(event.target.checked == true){
        event.target.dataValues.forEach(user=>{
          this.selectedUsersIds = [...this.selectedUsersIds, user.id]
        })
      }
      else if(event.target.checked == false){
        this.selectedUsersIds=[];
      }
    }
    // to handle single selection
    if (event.target.checked) {
      this.selectedUsersIds = [...this.selectedUsersIds, userId]
    }
    else {
      this.selectedUsersIds = this.selectedUsersIds.filter(id => id !== userId)
      
    }
    // to remove dublicates on selection
    this.selectedUsersIds=  this.selectedUsersIds.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
    // to remove undefined values
    this.selectedUsersIds = this.selectedUsersIds.filter(id => id !== undefined)    
  }

  setRecepientsIds() {
    this.createMessageFacade.setSelectedUsersIds(this.selectedUsersIds);
    this.messagesService._areMultipleRecepientsSelected.next(true)
    this.dialogRef.close()
  }

  onNoClick(): void {
    if(this.selectedUsersIds.length==0){
      this.messagesService._areMultipleRecepientsSelected.next(false)
    }
    this.dialogRef.close();
  }

}